import styled from '@emotion/styled/macro';

export const SpinnerWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.5);
  width: 100%;
  height: 100%;
`;
